export default __webpack_public_path__ + "static/media/show_related-icon.3d0299d3.svg";